import { signal } from "@preact/signals-react";
import {TagFrequency} from "stuen-common";

export const tagFrequencies = signal<TagFrequency[]>([]);

